import { Box, Button, IconButton } from "@mui/material";
import { Typography } from "@mui/material";
import { shareModalStyles } from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import { ContainerModal } from "../../pages/MyTracks/styles";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { TrackVersion } from "../../proto/api_pb";

export const DeleteVersionModal: React.FC<{
  isModalOpen: boolean;
  handleCloseModal: () => void;
  selectedVersion: TrackVersion | undefined;
  handleDeleteVersion: (v: TrackVersion | undefined) => void;
  isLoading: boolean;
}> = ({
  isModalOpen,
  handleCloseModal,
  selectedVersion,
  handleDeleteVersion,
  isLoading,
}) => {
  return (
    <ContainerModal
      open={isModalOpen}
      onClose={handleCloseModal}
      style={{ overflow: "auto" }}
    >
      <Box sx={{ ...shareModalStyles.mainContainer }}>
        <Box sx={shareModalStyles.topBarIconContainer}>
          <Box sx={shareModalStyles.shareIconContainer}>
            <DeleteOutlinedIcon />
          </Box>
          <Box sx={shareModalStyles.closeIconContainer}>
            <IconButton onClick={handleCloseModal}>
              <CloseIcon sx={{ fontSize: "30px" }} />
            </IconButton>
          </Box>
        </Box>
        <Typography sx={shareModalStyles.delteModalText}>
          Are you sure you want to remove this version?
        </Typography>
        <Box sx={shareModalStyles.buttonsContainer}>
          <Button
            onClick={() => handleDeleteVersion(selectedVersion)}
            sx={{ ...shareModalStyles.button, width: "48%" }}
          >
            Remove
          </Button>
          <Button sx={shareModalStyles.CancelButton} onClick={handleCloseModal}>
            Cancel
          </Button>
        </Box>
      </Box>
    </ContainerModal>
  );
};
